import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import FeedBackSectional from '../components/MT_Score/FeedBackSectional'

const MtScoreFeedbackSectional = () => {
  return (
    <>
    <Navbar />
    <FeedBackSectional />
    </>
  )
}

export default MtScoreFeedbackSectional